<div class="ir-area ir-mask th-mask">
  <form class="ir-modal th-modal">
    <modal-header [plugin]="plugin" [menuModal]="menuModal"></modal-header>
    <div class="ir-modal--body has-footer ir-pv8 ir-ph8">
      <div class="ir-content--modal th-content">
        <table class="ir-plugin-table" *ngIf="spoLockings?.length > 0">
          <tr class="th-plugin-line--header">
            <td colspan="3">
              <span>{{ 'plugins.spo-locking.os' | translate }}</span>
            </td>
            <td colspan="3">
              <span>{{ 'plugins.spo-locking.oos' | translate }}</span>
            </td>
          </tr>
          <tr class="th-plugin-line--subheader">
            <td>
              <span>N°</span>
            </td>
            <td class="th-plugin-line--value">
              <span>{{ 'plugins.spo-locking.gap' | translate }}</span>
            </td>
            <td class="th-plugin-line--value">
              <span>{{ 'plugins.spo-locking.os' | translate }}</span>
            </td>
            <td>
              <span></span>
            </td>
            <td class="th-plugin-line--value">
              <span>{{ 'plugins.spo-locking.oos' | translate }}</span>
            </td>
            <td class="th-plugin-line--value">
              <span>{{ 'plugins.spo-locking.gap' | translate }}</span>
            </td>
          </tr>
          <tr class="th-plugin-line--input" *ngFor="let item of spoLockings; let i = index">
            <td>
              <span>{{ item.Id }}.</span>
            </td>
            <td class="th-plugin-line--value important">
              <span>{{ item.OsGap | number : '1.2-2' }}</span>
            </td>
            <td class="th-plugin-line--value">
              <div class="ir-form-group margin">
                <input
                  [id]="'Os' + i"
                  name="item.Os-{{ i }}"
                  class="ir-form-set"
                  type="number"
                  min="0"
                  step="any"
                  (keydown.enter)="goToNext('Os' + (i + 1))"
                  [(ngModel)]="item.Os"
                  (ngModelChange)="calculate()"
                />
              </div>
            </td>
            <td>
              <span></span>
            </td>
            <td class="th-plugin-line--value">
              <div class="ir-form-group margin">
                <input
                  [id]="'Oss' + i"
                  name="Oss-{{ i }}"
                  class="ir-form-set"
                  type="number"
                  min="0"
                  step="any"
                  (keydown.enter)="goToNext('Oss' + (i + 1))"
                  [(ngModel)]="item.Oos"
                  (ngModelChange)="calculate()"
                />
              </div>
            </td>
            <td class="important">
              <span class="important">{{ item.OosGap | number : '1.2-2' }}</span>
            </td>
            <td class="th-plugin-line--remove">
              <i (click)="remove(item.Id)" class="material-icons">remove_circle</i>
            </td>
          </tr>
          <tr class="th-plugin-line--add">
            <td><i (click)="add()" class="material-icons">add_circle</i></td>
          </tr>
          <tr class="th-plugin-line--input">
            <td colspan="5">
              <span>{{ 'plugins.spo-locking.average' | translate }}</span>
            </td>
            <td>
              <span>{{ 'plugins.spo-locking.total-gap' | translate }}</span>
            </td>
          </tr>
          <tr class="th-plugin-line--input">
            <td colspan="2">
              <span>{{ 'plugins.spo-locking.gripper-bar' | translate }}</span>
            </td>
            <td class="th-plugin-line--value important">
              <span>{{ averageOs | number : '1.2-2' }}</span>
            </td>
            <td></td>
            <td class="th-plugin-line--value important">
              <span>{{ averageOos | number : '1.2-2' }}</span>
            </td>
            <td class="important">
              <span class="important">{{ averageGap | number : '1.2-2' }}</span>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <div class="ir-modal--footer ir-position--b th-modal--footer">
      <div class="ir-row">
        <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
          <div class="ir-btn ir-btn--big ir-btn--block th-btn-modal ir-txt--left" (click)="cancel()">
            <span>{{ 'common.cancel' | translate }}</span>
          </div>
        </div>
        <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
          <button
            type="button"
            class="ir-btn ir-btn--big ir-btn--block th-btn-modal--action ir-txt--right"
            (click)="save()"
            *ngIf="!processing"
          >
            <span>{{ 'common.save-changes' | translate }}</span>
          </button>
          <button class="ir-btn ir-btn--big ir-btn--block th-btn-disabled ir-txt--right" type="submit" *ngIf="processing">
            <span>{{ 'common.processing' | translate }}</span>
          </button>
        </div>
      </div>
    </div>
  </form>
</div>

<modal #menuModal (modalOutput)="selectMenu($event)"></modal>
<confirm
  #deleteConfirm
  (confirmOutput)="deletePlugin()"
  [title]="'common.delete-confirmation' | translate"
  [message]="'plugins.sure-to-delete' | translate"
  [danger]="true"
></confirm>
